import styled, { css } from 'styled-components';
import { media } from '@prisjakt/ui-base';
import { PrimaryButton, ButtonText } from '@prisjakt/ui/button/variants';

export const StoreLink = styled.div`
  display: flex;
  align-items: center;

  /* Small mobile resolutions, e.g. Galaxy Fold */
  @media screen and (max-width: 280px) {
    display: none;
  }
`;

type ButtonProps = {
  onlyIcon?: boolean;
};

export const Button = styled(PrimaryButton)<ButtonProps>(
  props => css`
    display: flex;
    width: 100%;

    ${props.onlyIcon &&
      css`
        width: auto;
      `}
  `
);

export const LinkDesktop = styled(PrimaryButton)<{
  $useSmallButton?: boolean;
}>`
  ${p =>
    !p.$useSmallButton &&
    media.smallOnly`
    display:none;
  `}

  ${p =>
    p.$useSmallButton &&
    css`
      padding-left: 0;
      padding-right: 0;
      height: 100%;
    `}
`;

export const LinkMobile = styled.div<{ $useSmallButton?: boolean }>`
  display: flex;
  align-items: center;

  ${media.mediumUp`
    display: none;
  `}

  ${p =>
    p.$useSmallButton &&
    css`
      display: none;
    `}
`;

export const LinkText = styled(ButtonText)<{ $isOurChoice?: boolean }>`
  ${p =>
    p.$isOurChoice &&
    css`
      display: none;
    `}
`;
